import * as React from "react";
import { forwardRef, memo } from "react";
const SvgFlagUnknown = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<circle cx={20} cy={20} r={20} fill="#D1D1D1" /></svg>;
const ForwardRef = forwardRef(SvgFlagUnknown);
const Memo = memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNEMUQxRDEiLz4KPC9zdmc+Cg==";